// extracted by mini-css-extract-plugin
export default {"base":"BaseButton_base__z6EqI","base_with-cursor-pointer":"BaseButton_base_with-cursor-pointer__qCeKT"};